import { useEffect } from 'react';
import { toast } from 'react-toastify';

export const useIntegrationCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const integration = params.get('integration');
    const status = params.get('status');

    if (integration) {
      const integrationName = integration === 'teams' ? 'Microsoft Teams' : integration;

      if (status === 'success') {
        toast.success(`${integrationName} connected successfully!`, {
          position: 'top-right',
          autoClose: 5000,
        });
      } else if (status === 'error') {
        const message = params.get('message');
        toast.error(`Failed to connect ${integrationName}: ${message || 'Unknown error'}`, {
          position: 'top-right',
          autoClose: 5000,
        });
      }

      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, []);
};

export default useIntegrationCallback;
